import React from "react";
import NotFound from "src/Screens/NotFound";
//import Invitation from "src/Screens/Invitation";
import Privacy from 'src/Screens/Privacy';
import Terms from 'src/Screens/Terms';

const Login = React.lazy(() => import('src/Screens/Public/Login'))
const Register = React.lazy(() => import('src/Screens/Public/Register'))
const Invitation = React.lazy(() => import('src/Screens/Public/Invitation'))

const Recovery = React.lazy(() => import('src/Screens/Public/Recovery'))

//Payment
const paymentView = React.lazy(() => import('src/Screens/Payment'));

const publicRoutes = [
    {
        path: "/",
        element: Login,
        isPrivate: false,
        exact: true
    },
    {
        path: "/invitation/:clientId",
        element: Invitation,
        isPrivate: false,
        exact: true
    },
    {
        path: "/recovery",
        element: Recovery,
        isPrivate: false,
        exact: true
    },
    {
        path: "/privacy",
        element: Privacy,
        isPrivate: false,
        exact: true
    },
    {
        path: "/terms",
        element: Terms,
        isPrivate: false,
        exact: true
    },
    {
        path: "/register",
        element: Register,
        isPrivate: false,
        exact: true
    },
    {
        path: "/payment",
        element: paymentView,
        isPrivate: true,
        exact: true
    }
];

export default publicRoutes;